'use strict';

var $ = require('jquery');
require('gwwp');

$(function() {

});

